// extracted by mini-css-extract-plugin
module.exports = {"section":"Section2_section__2OJeP","layout":"Section2_layout__1lHUX"};